import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
  Row,
  CardImg,
} from 'reactstrap';
import ImageGallery from '../../../propinfo/gallery/index';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import DynamicFlow from './DynamicFlow';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
let arr = [];
export default function AutonomousReplies({
  integration,
  integrationProperties,
  integrationId,
  allProperties,
  channelDetails,
  saveIntegration,
  lang,
  propertyList,
  channel,
}) {
  console.log('channel', channel);
  const defaultSettings = {
    enabled: false,
    instructions: '',
    mode: '',
    versionGPT3: '7',
    versionDynamicFlow:
      channel !== 'EmailAssistant' ? '6DynamicConverstionFlow' : '',
    assistantEnabled: channel !== 'EmailAssistant',
    generativeChatGPT: false,
    assistantId: '',
    dynamicConversationFlow: [],
    reasoningEfforts: 'minimal',
    verbosity: '',
  };
  const initialSettings = {
    ...defaultSettings,
    ...(channelDetails?.autonomousReplies || {}),
  };

  // Force defaults values for non - EmailAssistant channels
  if (channel !== 'EmailAssistant') {
    initialSettings.assistantEnabled = true;
    initialSettings.versionDynamicFlow = '6DynamicConverstionFlow';
    initialSettings.generativeChatGPT = false;
  }
  const [isReceivingEmail, setIsReceivingEmail] = useState(channelDetails !== null ? channelDetails.isReceivingEmail : false);
  const [autonomousSettings, setAutonomousSettings] = useState(initialSettings);
  const [assistantList, setAssistantList] = useState([]);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [aiAssistant, setAIAssistant] = useState(
    initialSettings.assistantId || ''
  );
  const [selectedProperty, setSelectedProperty] = useState(
    integrationProperties.length > 0 ? integrationProperties[0] : ''
  );
  const [rows, setRows] = useState(
    initialSettings.dynamicConversationFlow || []
  );
  const [propertyAssistant, setPropertyAssistant] = useState([]);
  useEffect(() => {
    loadResponse();
  }, integration);

  const handleReceiving = (e) => {
    var details = { ...channelDetails };
    details.isReceivingEmail = e;
    setIsReceivingEmail(e);
    saveIntegration({ channelDetails: details });
  };

  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setFormatedProperties(result);
  }, [integrationProperties, allProperties]);

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${'en'}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({
                id: l.openAiAssistantId,
                name: l.name,
                isGroupLevel: l?.isGroupVisible ?? false,
              });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };
  const handleSave = () => {
    autonomousSettings.reasoningEfforts = 'minimal';
    let settings = autonomousSettings;
    settings.dynamicConversationFlow = [...rows];
    channelDetails.autonomousReplies = autonomousSettings;
    console.log('auto', channelDetails);
    saveIntegration({ channelDetails });
  };

  const handleAutonmousSettings = (e) =>
    setAutonomousSettings({ ...autonomousSettings, enabled: e });

  const handleAutonmousChange = (e) =>
    setAutonomousSettings({
      ...autonomousSettings,
      [e.target.name]: e.target.value,
    });

  const handleAutonmousModeChange = (e) =>
    setAutonomousSettings({
      ...autonomousSettings,
      mode: e,
    });

  const handleCheckedGenerativeGTP3 = (e) => {
    var feat = { ...autonomousSettings };
    feat.generativeChatGPT = e;
    feat.assistantEnabled = false;
    setAutonomousSettings(feat);
  };

  const handleChange = (event) => {
    setSelectedProperty(event.target.value);
  };

  const handleChangeAssistantId = (e) => {
    setAIAssistant(e.target.value);
    var feat = { ...autonomousSettings };
    feat.assistantId = e.target.value;
    setAutonomousSettings(feat);
  };
  const handleCheckedOpenAIEnabled = (e) => {
    const feat = { ...autonomousSettings };
    feat.generativeChatGPT = false;
    feat.assistantEnabled = e;

    // Set versionDynamicFlow when assistantEnabled is turned on
    if (e) {
      feat.versionDynamicFlow = '6DynamicConverstionFlow';
    } else {
      feat.versionDynamicFlow = '';
    }
    console.log('feat', feat);
    setAutonomousSettings(feat);
  };

  // const handleCheckedOpenAIEnabled = (e) => {
  //   var feat = { ...autonomousSettings };
  //   feat.generativeChatGPT = false;
  //   feat.assistantEnabled = e;
  //   setAutonomousSettings(feat);
  // };

  // const handleVersionDynamicFlowChange = (e) => {
  //   var feat = { ...autonomousSettings };
  //   feat.versionDynamicFlow = e;
  //   setAutonomousSettings(feat);
  // };

  const handleVersionGPT3Change = (e) => {
    var feat = { ...autonomousSettings };
    feat.versionGPT3 = e;
    if (e === '7') {
      feat.reasoningEfforts = 'minimal';
    }
    setAutonomousSettings(feat);
  };
  // const handleReasoningEffortsChange = (e) => {
  //   var feat = { ...autonomousSettings };
  //   feat.reasoningEfforts = e;
  //   setAutonomousSettings(feat);
  // };
  const handleVerbosityChange = (e) => {
    var feat = { ...autonomousSettings };
    feat.verbosity = e;
    setAutonomousSettings(feat);
  };
  console.log(
    'channelin',
    autonomousSettings?.assistantEnabled,
    channel !== 'EmailAssistant'
  );
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Autonomous Replies</h6>
          </div>
          <Separator className="mb-3" />

          <Card className="m-4">
            <Colxx xxs="12" className="p-4">
              <Card className="p-3 mb-3">
                <Colxx md="12" className="px-0 mb-2 d-flex">
                  <h6 className="mr-2"> Enable</h6>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small "
                    checked={autonomousSettings?.enabled}
                    name="enabled"
                    onChange={(e) => handleAutonmousSettings(e)}
                  />
                </Colxx>
                <Colxx md="12" className="px-0">
                  <h6 className="">Autonomy Mode</h6>
                  <div className="">
                    <CustomInput
                      type="radio"
                      id="exAutoPilot"
                      name="AutoPilot"
                      label="Reply on auto pilot"
                      checked={autonomousSettings?.mode === 'AutoPilot'}
                      onChange={(e) => handleAutonmousModeChange('AutoPilot')}
                    />
                  </div>
                  <div className="">
                    <CustomInput
                      type="radio"
                      id="exHuman"
                      name="Human"
                      label="Human in the loop"
                      checked={autonomousSettings?.mode === 'Human'}
                      onChange={(e) => handleAutonmousModeChange('Human')}
                    />
                  </div>
                </Colxx>
              </Card>
              {channel !== 'EmailAssistant' && (
                <Fragment>
                  <Card className="p-3 mb-3">
                    <Fragment>
                      <div className="d-flex">
                        <h6>Store Usage Activity</h6>
                        <Switch
                          className="agentswitch custom-switch-primary custom-switch-small ml-2"
                          checked={isReceivingEmail}
                          name="Activity"
                          onChange={(e) => handleReceiving(e)}
                        />
                      </div>
                      <p className="">
                        Log email content, AI generated response and actions taken in the Outlook Add-in to the Unified Inbox
                      </p>
                    </Fragment>
                  </Card>
                </Fragment>
              )}
              <Card className="p-3 mb-3">
                <h6>Choose your NLP</h6>
                {channel === 'EmailAssistant' && (
                  <Fragment>
                    <div className="d-flex my-2">
                      <h6 className='mb-1'>Gen AI</h6>
                      <Switch
                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                        checked={autonomousSettings?.generativeChatGPT}
                        name="generativeChatGPT"
                        onChange={(e) => handleCheckedGenerativeGTP3(e)}
                      />
                    </div>
                    <p>
                      Gen AI excels at answering questions by using your
                      Knowledge Hub to provide accurate and relevant
                      information.
                    </p>
                  </Fragment>
                )}
                  {autonomousSettings.generativeChatGPT && (
                  <Fragment>
                    <div className="text-center my-2">
                      {/* <b>Select Version</b>
                      <br /> */}
                      <Input
                        type="select"
                        name="version"
                        value={autonomousSettings?.versionGPT3}
                        onChange={(e) =>
                          handleVersionGPT3Change(e.target.value)
                        }
                      >
                        <option value="">Select version</option>
                        <option value="6">Version 6 (GPT-4o-mini)</option>
                        <option value="7">Version 7 (GPT-5-mini)</option>
                        <option value="AzureGpt4">
                          {' '}
                          Azure OpenAI (gpt-4o-mini)
                        </option>
                      </Input>
                    </div>
                  </Fragment>
                )}
                {autonomousSettings.generativeChatGPT && autonomousSettings?.versionGPT3 === '7' && (
                  <Fragment>
                    {/* <div className="my-2">
                      <h7>Reasoning Efforts</h7>
                      <Input
                        type="select"
                        name="reasoningefforts"
                        value={autonomousSettings?.reasoningEfforts}
                        onChange={(e) => handleReasoningEffortsChange(e.target.value)}
                        className="mt-1"
                      >
                        <option value="">Select</option>
                        <option value="minimal">Minimal</option>
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                      </Input>
                    </div> */}
                    <div className="mt-1 mb-2">
                      <b>Verbosity</b>
                      <Input
                        type="select"
                        name="verbosity"
                        value={autonomousSettings?.verbosity}
                        onChange={(e) =>
                          handleVerbosityChange(e.target.value)
                        }
                        className="mt-1"
                      >
                        <option value="">Select</option>
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                      </Input>
                    </div>
                  </Fragment>
                )}
                <div className="d-flex my-2">
                  <h6>Dynamic Conversation Flow</h6>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={autonomousSettings?.assistantEnabled}
                    name="openAIisEnabled"
                    onChange={(e) => handleCheckedOpenAIEnabled(e)}
                  />
                </div>
                <p>
                  Conversation flows are useful to provide more detailed,
                  step-by-step instructions to guide a customer through a
                  process or task until completion.
                </p>
          
                {autonomousSettings?.assistantEnabled === true && formatedProperties !== null && (
                  <Fragment>
                    {formatedProperties.length > 1 && (
                      <div className="my-2">
                        <h6>Properties</h6>
                        <Input
                          className="border py-2 pl-2 pr-3 mt-3 "
                          type={
                            formatedProperties.length > 1 ? 'select' : 'text'
                          }
                          name="Property Id"
                          value={
                            formatedProperties.length > 1
                              ? selectedProperty
                              : `${formatedProperties[0].name} (${formatedProperties[0].id})`
                          }
                          onChange={
                            formatedProperties.length > 1
                              ? handleChange
                              : undefined
                          }
                        >
                          {formatedProperties.length > 1 ? (
                            formatedProperties.map((list, index) => (
                              <option key={index} value={list.id}>
                                {`${list.name} (${list.id})`}
                              </option>
                            ))
                          ) : (
                            <>
                              {`${formatedProperties[0].name} (${formatedProperties[0].id})`}
                            </>
                          )}
                        </Input>
                      </div>
                    )}
                  </Fragment>
                )}
                {assistantList && assistantList !== null && autonomousSettings?.assistantEnabled === true && (
                  <Fragment>
                    <div className="my-2">
                      {/* <h6>Dynamic Conversation Flow</h6> */}
                      {assistantList.length > 0 ? (
                        <Input
                          className="border pr-4"
                          type="select"
                          name="assistantId"
                          placeholder="Dynamic Conversation Flow"
                          value={aiAssistant}
                          onChange={handleChangeAssistantId}
                        >
                          <option value="">
                            Select a Dynamic Conversation Flow
                          </option>
                          {assistantList.map((assist, index) => (
                            <option key={index} value={assist.id}>
                              {assist.isGroupLevel
                                ? `${assist.name} (${assist.id}) (Group Level)`
                                : `${assist.name} (${assist.id})`}
                            </option>
                          ))}
                        </Input>
                      ) : (
                        <Input
                          className="border p-2 mb-2"
                          type="text"
                          name="assistantId"
                          onChange={handleChangeAssistantId}
                          placeholder="Dynamic Conversation Flow"
                          defaultValue={aiAssistant}
                        />
                      )}
                      {/* <Input
                          type="select"
                          name="versionDynamicFlow"
                          value={autonomousSettings?.versionDynamicFlow}
                          onChange={(e) =>
                            handleVersionDynamicFlowChange(e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          <option value="6DynamicConverstionFlow">
                            Version 6 (with Dynamic Conversation Flow)
                          </option>
                        </Input> */}
                    </div>
                  </Fragment>
                )}
              
              </Card>
              <Fragment>
                {autonomousSettings.generativeChatGPT && (
                  <Card className="p-3 mb-3">
                    <h6>Generative AI (GPT) instructions for Email</h6>
                    <p className="mb-2">
                      Hint: Add a line that’s appended to every customer
                      query before sending it to the GPT models. This
                      provides guidance to the model.
                    </p>
                    <Input
                      className="form-control mb-2"
                      style={{ lineHeight: "1.3" }}
                      name="instructions"
                      type="textarea"
                      placeholder="You are a phone assistant working for the Paradise Resort. Be truthful and precise."
                      defaultValue={autonomousSettings?.instructions}
                      onChange={(e) => { handleAutonmousChange(e); }}
                    />
                  </Card>
                )}
              </Fragment>
              <DynamicFlow
                lang={lang}
                propertyList={propertyList}
                integrationId={integration.id}
                channelDetails={integration.channelDetails}
                rows={rows}
                setRows={setRows}
                propertyAssistant={propertyAssistant}
                setPropertyAssistant={setPropertyAssistant}
              />
            </Colxx>
          </Card>

          <Separator className="my-3" />
          <Colxx md="12" className="text-center">
            <Button onClick={() => handleSave()} color="primary" size="xs">
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
